"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var specialTopics = [
    {
        key: 'businessValuation',
        name: 'Business Valuation',
        short: 'BV'
    },
    {
        key: 'coachingMentoring',
        name: 'Coaching / Mentoring',
        short: 'CM'
    },
    {
        key: 'constructionSpecific',
        name: 'Construction Specific',
        short: 'CS'
    },
    {
        key: 'employeeBenefitPlan',
        secondary_key: 'employee_benefit',
        name: 'Employee Benefit Plans',
        short: 'EBP'
    },
    {
        key: 'federalTaxes',
        name: 'Federal Taxes',
        short: 'FT'
    },
    {
        key: 'financialForensics',
        name: 'Financial Forensics',
        short: 'FF'
    },
    {
        key: 'financialPlanning',
        name: 'Financial Planning',
        short: 'FP'
    },
    {
        key: 'fraud',
        name: 'Fraud',
        short: 'F'
    },
    {
        key: 'fsp',
        name: 'Financial Statement Presentation',
        short: 'FSP'
    },
    {
        key: 'hud',
        name: 'Housing and Urban Development',
        short: 'HUD'
    },
    {
        key: 'shpt',
        secondary_key: 'sexual_harassment',
        name: 'Sexual Harassment Prevention Training',
        short: 'SHPT'
    },
    {
        key: 'yellowbook',
        compliance_key: 'proficiency',
        name: 'Yellowbook Proficiency',
        short: 'YB'
    }
];
exports.specialTopics = specialTopics;
//# sourceMappingURL=specialTopics.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@prolaera/library/dist/specialTopics.js
// module id = 893
// module chunks = 0